<lx-single-selection-button-list-field
  (ngModelChange)="setSelectedCourse($event)"
  [disabled]="courseSelectorDisabled"
  [extended]="true"
  [ngModel]="selectedCourse?.code"
  [options]="courses$ | async"
  [preselected]="false"
  data-qa="juniorsCourseRadioButtons_field"
  bindValue="code"
  i18n-title
  title="Course"
></lx-single-selection-button-list-field>

<lx-juniors-course-upgrade-popup
  (upgradedCourse)="upgradeCourse($event)"
  [visible]="juniorCourseUpgradePopup"
  data-qa="juniorsCourseUpgrade_field"
></lx-juniors-course-upgrade-popup>
